// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { invItemId } from './InvItem';
import { z } from 'zod';
export const invItemLifecycleEventId = (z.number());
export const invItemLifecycleEvent = z.object({
    id: invItemLifecycleEventId,
    item_id: invItemId,
    event_type: z.string(),
    event_timestamp: z.date().nullable(),
    operator_id: z.number().nullable(),
    metadata: z.unknown().nullable(),
    notes: z.string().nullable(),
});
export const invItemLifecycleEventInitializer = z.object({
    id: invItemLifecycleEventId.optional(),
    item_id: invItemId,
    event_type: z.string(),
    event_timestamp: z.date().optional().nullable(),
    operator_id: z.number().optional().nullable(),
    metadata: z.unknown().optional().nullable(),
    notes: z.string().optional().nullable(),
});
export const invItemLifecycleEventMutator = z.object({
    id: invItemLifecycleEventId.optional(),
    item_id: invItemId.optional(),
    event_type: z.string().optional(),
    event_timestamp: z.date().optional().nullable(),
    operator_id: z.number().optional().nullable(),
    metadata: z.unknown().optional().nullable(),
    notes: z.string().optional().nullable(),
});
//# sourceMappingURL=InvItemLifecycleEvent.js.map